import React, { createContext, useContext, ReactNode } from 'react';

export interface AuthenticatedUser {
    login: string;
    isAuthorizedForSLAOverrides: boolean;
    isDevAdmin: boolean;
    isAFTX: boolean;
    warehouseId?: string;
}

interface UserContextType {
    user: AuthenticatedUser | null;
    setUser: (user: AuthenticatedUser | null) => void;
    isInitialized: boolean;
    setIsInitialized: (initialized: boolean) => void;
}


const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
    const [user, setUser] = React.useState<AuthenticatedUser | null>(null);
    const [isInitialized, setIsInitialized] = React.useState(false);

    const value = React.useMemo(() => ({
        user,
        setUser,
        isInitialized,
        setIsInitialized
    }), [user, isInitialized]);

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}
